import {createTheme, ThemeOptions} from '@material-ui/core';
import {lighten} from '@material-ui/core/styles';

const commonOptions : ThemeOptions = {
    palette: {
        primary: {
            light: '#66a9c8',
            main: '#327a97',
            dark: '#004e69',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ffeb5d',
            main: '#dfb927',
            dark: '#a98a00',
            contrastText: '#000',
        },
        error: {
            light: '#e57373',
            main: '#f44336',
            dark: '#d32f2f',
            contrastText: '#fff',
        },
        success: {
            main: '#4caf50',
            contrastText: '#fff',
        },
    },
    props: {
        MuiTextField: {
            margin: 'normal',
        },
        MuiFormControl: {
            margin: 'normal',
        },
    },
};

declare module '@material-ui/core/styles/createTheme' {
    interface Theme {
        custom : {
            tableHeader : string;
            tableFooter : string;
        };
    }

    interface ThemeOptions {
        custom ?: {
            tableHeader ?: string;
            tableFooter ?: string;
        };
    }
}

export const lightTheme = createTheme({
    custom: {
        tableHeader: lighten('#327a97', 0.6),
        tableFooter: lighten('#66a9c8', 0.8)
    },
}, commonOptions);
export const darkTheme = createTheme({
    palette: {
        type: 'dark',
    },
    custom: {
        tableHeader: '#327a97',
        tableFooter: '#66a9c8',
    },
}, commonOptions);
